import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../theme';

const useStyles = (hasCurrent) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: hasCurrent ? 'column' : 'row',
        color: colorsPalette.grayThird,
        paddingBottom: hasCurrent ? 44 : 0,
        marginBottom: hasCurrent ? 24 : 13,
        borderBottom: hasCurrent ? `2px solid ${colorsPalette.blueDark}` : 'none',

        '&:last-child': {
          paddingBottom: hasCurrent ? 24 : 0,
          borderBottom: 'none',
        },

        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 13,
          paddingBottom: 0,
          borderBottom: 'none',

          '&:last-child': {
            paddingBottom: 0,
          },
        },
      },
      itemLeftBlock: {
        color: colorsPalette.white,
        fontWeight: 'bold',
        flex: hasCurrent ? 'unset' : 1,

        '& img': {
          width: 62,
          height: 43,
          objectFit: 'cover',
        },

        width: hasCurrent ? 'unset' : '60%',

        [theme.breakpoints.up('md')]: {
          width: '60%',
        },
      },
      itemLeftBlockInner: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 18,
      },
      videoItemPreviewWrapper: {
        position: 'relative',
        marginRight: SMALL_MARGIN,
        height: 43,
      },
      playIcon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        zIndex: 5,
        width: 15,
        height: 17,
        transform: 'translate(-50%, -50%)',
      },
      tableTitle: {
        overflow: 'hidden',
        margin: 0,
        '&:not(:only-child)': {
          marginBottom: 2,
        },
      },
      itemHref: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',
        color: colorsPalette.white,

        '&:hover': {
          color: colorsPalette.blue,
        },
      },
      helperText: {
        margin: 0,
        color: colorsPalette.violet,
        fontSize: 14,
        lineHeight: '18px',
        fontWeight: 'normal',
        [theme.breakpoints.up('md')]: {
          fontSize: 16,
          lineHeight: '20px',
        },
      },
      greenLabel: {
        color: colorsPalette.green,
      },
      redLabel: {
        color: colorsPalette.failedError,
      },
      progressLineWrapper: {
        width: '100%',
        marginTop: 24,
        marginBottom: 0,

        [theme.breakpoints.up('md')]: {
          marginTop: 26,
          width: '35%',
        },
      },
      videoItemDuration: {
        marginLeft: 18,
        color: colorsPalette.gray,
        fontSize: 16,
        lineHeight: 1,
      },
    }),
  );
export default useStyles;
